import React, { useState, useEffect } from "react";
import DashboardHeader from "../../../components/layout/DashboardHeader";
import Sidebar from "../../../components/layout/Sidebar";
import { IoSearch } from "react-icons/io5";
import axios from "axios";
import { BASE_URL } from "../../../env";
import { MdModeEdit } from "react-icons/md";
import { Modal, Button, Form, Pagination } from "react-bootstrap";

const AdminPermissions = () => {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(window.innerWidth > 992);
  const [roles, setRoles] = useState([]);
  const [matrix, setMatrix] = useState([]);

  const OpenSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  useEffect(() => {
    fetchMatrix();
  }, []);

  const fetchMatrix = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/getPermissionsMatrix`);
      setRoles(response.data.roles);
      setMatrix(response.data.matrix);
    } catch (error) {
      console.error("Error fetching permissions matrix:", error);
    }
  };

  const handleCheckboxChange = async (roleId, reportId, currentView) => {
    try {
      await axios.post(`${BASE_URL}/api/updatePermissionForRole`, {
        roleId,
        reportId,
        view: !currentView,
      });
      fetchMatrix(); // Refresh the matrix after update
    } catch (error) {
      console.error("Error updating permission:", error);
    }
  };

  return (
    <section className="master-layout">
      <div className="master-sidebar-wrapper">
        <Sidebar
          openSidebarToggle={openSidebarToggle}
          OpenSidebar={OpenSidebar}
        />
      </div>
      <div className="master-content-wrapper">
        <div className="master-header-wrapper">
          <DashboardHeader OpenSidebar={OpenSidebar} />
        </div>

        <div className="master-card-container">
          <div className="master-list-section" style={{ padding: "15px" }}>
            <div className="TableHeaderText">Permissions Matrix</div>
            <div className="master-table-wrapper table-responsive">
              <table className="table table-striped table-bordered table-list">
                <thead
                  style={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#252525",
                    color: "#fafafa",
                    border: "#343434",
                    zIndex: 1,
                  }}
                >
                  <tr>
                    <th style={{ fontWeight: "400" }}>Reports</th>
                    {roles.map((role) => (
                      <th key={role.id} style={{ fontWeight: "400" }}>
                        {role.roleName}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {matrix.map((row) => (
                    <tr key={row.reportId}>
                      <td>{row.reportName}</td>
                      {roles.map((role) => (
                        <td key={`${role.id}-${row.reportId}`}>
                          <input
                            type="checkbox"
                            checked={row[role.roleName] || false}
                            onChange={() =>
                              handleCheckboxChange(
                                role.id,
                                row.reportId,
                                row[role.roleName]
                              )
                            }
                          />
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdminPermissions;
